"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = require("react");
var _chunk = _interopRequireDefault(require("lodash/chunk"));
var useFocusGroup = function useFocusGroup(className) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$ltr = _ref.ltr,
    ltr = _ref$ltr === void 0 ? true : _ref$ltr;
  if (!className.startsWith('.')) {
    throw new Error("useFocusGroup:\nExpected: a class name selector as a parameter (string that starts with a dot).\nReceived: \"".concat(className, "\""));
  }
  if (className.split(' ').length === 1) {
    window.console.warn("useFocusGroup:\nIt's highly recommended to pass a selector that includes the class name of the element that contains all the items you want to group.\nThis is essential in order to avoid querying generic components that are rendered simultaneously on different parts of the screen." + "%c\nBad: \".item\"" + "%c\nGood: \".container .item\"", 'color: red', 'color: lightgreen');
  }
  var lastFocusedItem = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    window.addEventListener('keydown', onKeyDown);
    return function () {
      return window.removeEventListener('keydown', onKeyDown);
    };
    function onKeyDown(event) {
      var key = event.key;
      var target = event.target;
      if (!KEYS.includes(key)) {
        return;
      }
      var items = (0, _toConsumableArray2["default"])(document.querySelectorAll(className));
      if (!items.length) {
        return;
      }
      items.forEach(function (item) {
        item.querySelectorAll('*').forEach(function (descendant) {
          if (item !== lastFocusedItem.current && descendant.tabIndex > -1) {
            descendant.setAttribute(focusAttr, 'true');
            descendant.tabIndex = -1;
          }
        });
      });
      var rows = function () {
        var container = items[0].parentElement;
        var _getComputedStyle = getComputedStyle(container),
          display = _getComputedStyle.display,
          gridTemplateColumns = _getComputedStyle.gridTemplateColumns;
        if (display === 'grid') {
          var columnCount = gridTemplateColumns.split(' ').length;
          return (0, _chunk["default"])(items, columnCount);
        }
        if (items.every(function (item) {
          return item.parentElement === container;
        })) {
          return items.map(function (item) {
            return [item];
          });
        }
        return items.filter(function (item) {
          return item === item.parentElement.firstElementChild;
        }).map(function (item) {
          return (0, _toConsumableArray2["default"])(item.parentElement.children);
        });
      }();
      if (key === 'Tab') {
        setLastFocusedItem(lastFocusedItem.current);
        return;
      }
      var _ref2 = function () {
          var itemIndex;
          var rowIndex = rows.findIndex(function (row) {
            var currIndex = row.findIndex(function (item) {
              return item === target || item.contains(target);
            });
            if (currIndex !== -1) {
              itemIndex = currIndex;
              return true;
            }
          });
          return [rowIndex, itemIndex];
        }(),
        _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
        currRowIndex = _ref3[0],
        currItemIndex = _ref3[1];
      if (currItemIndex === undefined) {
        return;
      }
      var nextItem = function () {
        switch (key) {
          case 'ArrowUp':
            {
              var rowIndex = currRowIndex - 1;
              while (rowIndex > -rows.length) {
                var item = rows.at(rowIndex).at(currItemIndex);
                if (isFocusable(item)) {
                  return item;
                }
                rowIndex--;
              }
              break;
            }
          case 'ArrowDown':
            {
              var _rowIndex = currRowIndex - rows.length + 1;
              while (_rowIndex < rows.length) {
                var _item = rows.at(_rowIndex).at(currItemIndex);
                if (isFocusable(_item)) {
                  return _item;
                }
                _rowIndex++;
              }
              break;
            }
          case 'ArrowLeft':
            {
              if (!ltr) {
                return;
              }
              var _rowIndex2 = currRowIndex;
              var itemIndex = currItemIndex - 1;
              while (_rowIndex2 > -rows.length - 1) {
                while (itemIndex > -1) {
                  var _item2 = rows.at(_rowIndex2).at(itemIndex);
                  if (isFocusable(_item2)) {
                    return _item2;
                  }
                  itemIndex--;
                }
                _rowIndex2--;
                itemIndex = rows.at(_rowIndex2).length - 1;
              }
              break;
            }
          case 'ArrowRight':
            {
              if (!ltr) {
                return;
              }
              var _rowIndex3 = currRowIndex - rows.length;
              var _itemIndex = currItemIndex + 1;
              while (_rowIndex3 < rows.length) {
                while (_itemIndex < rows.at(_rowIndex3).length) {
                  var _item3 = rows.at(_rowIndex3).at(_itemIndex);
                  if (isFocusable(_item3)) {
                    return _item3;
                  }
                  _itemIndex++;
                }
                _rowIndex3++;
                _itemIndex = 0;
              }
              break;
            }
        }
      }();
      if (isFocusable(nextItem)) {
        event.preventDefault();
        setLastFocusedItem(nextItem);
        nextItem.focus();
      }
      function isFocusable(item) {
        return item && document.body.contains(item) && item.getAttribute('aria-disabled') !== 'true' && item.getAttribute('inert') !== 'true' && !item.disabled;
      }
      function setLastFocusedItem(item) {
        lastFocusedItem.current = isFocusable(item) ? item : items.find(isFocusable);
        items.forEach(function (currItem) {
          var tabIndex = currItem === lastFocusedItem.current ? 0 : -1;
          currItem.tabIndex = tabIndex;
          currItem.querySelectorAll('*').forEach(function (descendant) {
            if (descendant.getAttribute(focusAttr) === 'true') {
              descendant.tabIndex = tabIndex;
            }
          });
        });
      }
    }
  }, [className, ltr]);
  return {
    lastFocusedItem: lastFocusedItem
  };
};
var _default = exports["default"] = useFocusGroup;
var focusAttr = 'data-focusable-descendant';
var KEYS = ['Tab', 'ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'];
//# sourceMappingURL=useFocusGroup.js.map